import * as Helper from "./reset_action";

import { LOGIN_USER } from "../../constants/reducer_names";
import { combineReducers } from "redux";
import { meetingReducer } from "../../base/reducer/meetReducer";
import { mediaDeviceInfo } from "../../base/reducer/mediaDeviceInfo";
import { userAgent } from "../../base/reducer/userAgent";
import { storeVideo } from "../../base/reducer/storeVideo";
import closeCaption from "../../base/reducer/closeCaption";
import { messageReducer } from "../../base/reducer/messageReducer";
import sharingReducerState from "../../base/reducer/screenShareReducer";
import { VirtualBG } from "../../base/reducer/virtualBG";
import { verificationReducer } from "../../base/reducer/verificationReducer";

const combinedReducers = combineReducers({
  loginUser: Helper.LoginUserReducerWrapper,
  forgotPassword: Helper.ForgotPasswordReducerWrapper,
  resetLink: Helper.ResetLinkReducerWrapper,
  userInformation: Helper.UserInformationReducerWrapper,
  userList: Helper.UserListReducerWrapper,
  userListDetail: Helper.UserDetailsReducerWrapper,
  userSettings: Helper.UserSettingsReducerWrapper,
  agentStatus: Helper.agentstatusListReducerWrapper,
  businessHours: Helper.BusinessHoursReducerWrapper,
  createCustomerTags: Helper.CreateCustomerTagReducerWrapper,
  getCustomerTags: Helper.GetCustomerTagReducerWrapper,
  updateCustomerTags: Helper.UpdateCustomerTagReducerWrapper,
  deleteCustomerTags: Helper.DeleteCustomerTagReducerWrapper,
  isValidCustomerTag: Helper.IsValidCustomerTagReducerWrapper,
  Skillmanagement: Helper.skillmanagementReducerWrapper,
  queueTracker: Helper.QueueTrackerReducerWrapper,
  agentTracker: Helper.AgentTrackerReducerWrapper,
  sideBar: Helper.SidebarWrapper,
  notification: Helper.NotificationWrapper,
  playPrompt: Helper.playPromptReducerWrapper,
  userHelpers: Helper.userManagementHelpersWrapper,
  EdituserDetails: Helper.EditUserManagerWrapper,
  routingList: Helper.RoutingListReducerWrapper,
  contactCenterNumber: Helper.ContactCenterNumberReducerWrapper,
  customQueue: Helper.CustomQueueReducerWrapper,
  reportsDataa: Helper.AnalyticsChartsWrapper,
  nodeFlow: Helper.NodeFlowReducerWrapper,
  metaTemplates: Helper.MetaTemplatesReducerWrapper,
  chatConfiguration: Helper.ChatConfigurationReducerWrapper,
  supervisorContactData: Helper.supervisorContactWrapper,
  chatReducer: Helper.ChatReducerWrapper,
  callLoginUserAgent: Helper.CallUserAgentReducerWrapper,
  callPopUpDetails: Helper.CallPOpUpAgnetModelWrapper,
  contactListForAgent: Helper.ContactListModelWrapper,
  sms: Helper.smsModelWrapper,
  coChat: Helper.coChatWrapper,
  coChatDetails: Helper.coChatDetailsWrapper,
  internalChatDetails: Helper.internalChatWrapper,
  coChatUserDetails: Helper.coChatUserDetailsReducerWrapper,
  dispositionData: Helper.dispositionStatusWrapper,
  shortcutKeys: Helper.shortcutKeysReducerWrapper,
  emailConfigData: Helper.emailConfigWrapper,
  reportsCallReducer: Helper.reportCallAnsweredWrapper,
  dashboardData: Helper.dashBoardWrapper,
  queueAnalyticsVoice: Helper.queueAnalyticsVoiceWrapper,
  queueAnalyticsWebchat: Helper.queueAnalyticsWebchatWrapper,
  queueAnalyticsSocicalMedia: Helper.queueAnalyticsSocialMediaWrapper,
  agentAnalyticsWebchat: Helper.agentAnalyticsWebchatWrapper,
  agentAnalyticsEmail: Helper.agentAnalyticsEmailWrapper,
  agentAnalyticsVoice: Helper.agentAnalyticsVoiceWrapper,
  agentAnalyticsSMS: Helper.agentAnalyticsSMSWrapper,
  agentAnalyticsWhatsApp: Helper.agentAnalyticsWhatsAppWrapper,
  agentAnalyticsFacebook: Helper.agentAnalyticsFacebookWrapper,
  agentAnalyticsInstagram: Helper.agentAnalyticsInstagramWrapper,
  allActivity: Helper.allActivityReducerWrapper,
  agentState: Helper.agentstateReducerWrapper,
  newEntryEmailData: Helper.newEmailWrapper,
  qaBotsettingsData: Helper.qaBotsettings,
  standAloneBotData: Helper.StandAloneBotWrapper,
  KnowledgeBase: Helper.KnowledgeBaseWrapper,
  connectors: Helper.ConnectorsWrapper,
  liveTracker: Helper.LiveTrackerWrapper,
  apiIntegration: Helper.ApiIntegrationWrapper,
  callConfig: Helper.callConfigWrapper,
  whatsappConfig: Helper.WhatsppConfigWrapper,
  facebookConfig: Helper.FacebookConfigWrapper,
  socialmediaWidget: Helper.SocialmediaWidgetWrapper,
  mediaDevice: mediaDeviceInfo,
  screenshare: Helper.ScreenShareWrapper,
  // meetingReducer:Helper.MeetReducerWrapper,
  meetingReducer: meetingReducer,
  VirtualBG:VirtualBG,
  storeVideo: storeVideo,
  closeCaption: closeCaption,
  // userAgent: Helper.videoAgentWrapper
  userAgent: userAgent,
  verificationReducer:verificationReducer,
  messageReducer: messageReducer,
  sharingReducerState: sharingReducerState,
  customerSatisfaction:Helper.CustomerSatisfactionReducerWrapper,
  dynamicDashboard: Helper.DynamicdDashboardReducerWrapper,
  outboundcampaign:Helper.OutboundCampaignWrapper,


});

const rootReducer = (state: any, action: any) => {
  if (action.type === `${LOGIN_USER}/logout`) state = undefined;
  return combinedReducers(state, action);
};

export default rootReducer;
